/**
 * Read-only planogram policy for viewer pages: the Konva stage presents the
 * POG for inspection (pan, zoom, hover) — structure never changes from the
 * canvas. Product selection is available for inspection; movement is refused.
 */
import {
  emptyPlanogramSelection,
  type PlanogramPolicy,
} from "src/components/Planogram/components/KonvaPlanogram";

export const konvaViewerPolicy: PlanogramPolicy = {
  canMove: false,
  canSelect: (entity) => entity.kind === "product" || entity.kind === "placement",
  evaluate: () => ({ allowed: false, reason: "unsupported-movement" }),
  execute: ({ pog, selection }) => ({
    pog,
    selection: selection ?? emptyPlanogramSelection,
    status: "rejected",
    reason: "unsupported-movement",
  }),
};
